export default __webpack_public_path__ + "static/media/Champions-League-Experience.d5d3f13e.png";